if (!customElements.get('signature-sticky-filters')) {
  class SignatureStickyFilters extends HTMLElement {
    constructor() {
      super();
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.handleToolbarIntersect = this.handleToolbarIntersect.bind(this);
      this.handleSentinelIntersect = this.handleSentinelIntersect.bind(this);
      this.toolbarPassed = false;
      this.contentEnding = false;
    }

    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;

      this.toolbarEl = document.querySelector(this.dataset.toolbarSelector);
      this.sentinelEl = document.querySelector(this.dataset.endSentinelSelector);
      this.trigger = this.querySelector('[data-sticky-filter-trigger]');

      if (this.toolbarEl) {
        this.toolbarObserver = new IntersectionObserver(this.handleToolbarIntersect, { threshold: 0 });
        this.toolbarObserver.observe(this.toolbarEl);
      }

      if (this.sentinelEl) {
        this.sentinelObserver = new IntersectionObserver(this.handleSentinelIntersect, {
          rootMargin: '0px 0px 20% 0px',
          threshold: 0,
        });
        this.sentinelObserver.observe(this.sentinelEl);
      }

      if (this.trigger) this.trigger.addEventListener('click', this.handleTriggerClick);
    }

    disconnectedCallback() {
      if (this.toolbarObserver) this.toolbarObserver.disconnect();
      if (this.sentinelObserver) this.sentinelObserver.disconnect();
      if (this.trigger) this.trigger.removeEventListener('click', this.handleTriggerClick);
    }

    handleToolbarIntersect(entries) {
      const entry = entries[0];
      this.toolbarPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      this.updateVisibility();
    }

    handleSentinelIntersect(entries) {
      const entry = entries[0];
      this.contentEnding = entry.isIntersecting || entry.boundingClientRect.top <= 0;
      this.updateVisibility();
    }

    updateVisibility() {
      this.classList.toggle('is-visible', this.toolbarPassed && !this.contentEnding);
    }

    handleTriggerClick(event) {
      event.preventDefault();
      if (this.toolbarEl && typeof this.toolbarEl.click === 'function') {
        this.toolbarEl.click();
      }
    }
  }

  customElements.define('signature-sticky-filters', SignatureStickyFilters);
}
